import dayjs from "dayjs";

const VENCIDO_YEAR_FROM = 2020;

export function buildMapByCliente(raw) {
  const map = {};
  (raw || []).forEach((d) => {
    d.clientes?.forEach((c) => {
      if (!map[c.nombre]) map[c.nombre] = {};
      map[c.nombre][d.fecha] = c.importe;
    });
  });
  return map;
}

export function buildMapByProveedor(raw) {
  const map = {};
  (raw || []).forEach((d) => {
    d.proveedores?.forEach((p) => {
      if (!map[p.nombre]) map[p.nombre] = {};
      map[p.nombre][d.fecha] = p.importe;
    });
  });
  return map;
}

export function extractClienteDays(raw) {
  const days = new Set();
  (raw || []).forEach((d) => {
    if (d.clientes?.length) days.add(d.fecha);
  });
  return [...days].sort((a, b) => dayjs(a).diff(dayjs(b)));
}

export function extractProveedorDays(raw) {
  const days = new Set();
  (raw || []).forEach((d) => {
    if (d.proveedores?.length) days.add(d.fecha);
  });
  return [...days].sort((a, b) => dayjs(a).diff(dayjs(b)));
}

/** Años a consultar para calcular saldos vencidos (histórico + año seleccionado). */
export function getYearsForVencidoQuery(selectedYear) {
  const current = dayjs().year();
  const end = Math.max(current, Number(selectedYear) || current) + 1;
  const years = new Set([Number(selectedYear) || current]);

  for (let y = VENCIDO_YEAR_FROM; y <= end; y += 1) {
    years.add(y);
  }

  return [...years].sort((a, b) => a - b);
}

export function mergeMapByEntity(...maps) {
  const merged = {};

  maps.forEach((map) => {
    Object.entries(map || {}).forEach(([name, byDate]) => {
      if (!merged[name]) merged[name] = {};
      Object.entries(byDate || {}).forEach(([fecha, importe]) => {
        merged[name][fecha] = (merged[name][fecha] || 0) + (Number(importe) || 0);
      });
    });
  });

  return merged;
}

/**
 * Agrupa importes vencidos (fecha < hoy) por año natural de la fecha.
 * Solo devuelve años con saldo distinto de cero.
 */
export function calcImporteVencidoPorAnio(
  mapByEntity,
  today = dayjs(),
  { absAmount = false } = {},
) {
  const cutoff = today.startOf("day");
  const byYear = {};

  Object.values(mapByEntity || {}).forEach((byDate) => {
    Object.entries(byDate || {}).forEach(([fecha, importe]) => {
      const d = dayjs(fecha);
      if (!d.isBefore(cutoff, "day")) return;

      const y = d.year();
      const val = Number(importe) || 0;
      byYear[y] = (byYear[y] || 0) + val;
    });
  });

  return Object.entries(byYear)
    .map(([y, total]) => ({
      year: Number(y),
      amount: absAmount ? Math.abs(total) : total,
    }))
    .filter(({ amount }) => Math.abs(amount) > 0.005)
    .sort((a, b) => a.year - b.year);
}

export function formatAmount(val) {
  return Number(val || 0).toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
